import React from "react"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const OverridesDatesSkeleton = () => {
   return (
      <div className="production-line-skeleton">
         <div className="production-line-skeleton-col justify-content-end">
            <UnitSkeleton shape="rounded" size="small" />
         </div>
         <UnitSkeleton shape="rounded" size="large" />
         <UnitSkeleton shape="rounded" size="large" />
         <UnitSkeleton shape="rounded" size="large" />
      </div>
   )
}

export default OverridesDatesSkeleton
